export const translations = {
  en: {
    nav: {
      home: "Home",
      about: "About",
      services: "Services",
      digital: "Digitia",
      contact: "Contact",
      cta: "Free Consultation",
    },
    common: {
      free_consultation: "Free Consultation",
      whatsapp_now: "WhatsApp Now",
      contact_us: "Contact Us",
      learn_more: "Learn More",
      our_divisions: "Our Divisions",
      primary_division: "Advisory Division",
      secondary_division: "Digital Division",
      brand: "Mercurio Advisors Group",
      brand_short: "Mercurio",
      brand_sub: "Advisors Group",
      slogan: "Advising Beyond Borders",
    },
    hero: {
      overline: "Valencia · Spain · Europe",
      title_a: "Advising",
      title_b: "Beyond",
      title_c: "Borders",
      sub:
        "Mercurio Advisors Group helps individuals, families, entrepreneurs and businesses navigate life and commerce in Spain and Europe — from visas and admissions to company setup, digital transformation and everything in between.",
      europath_label: "Advisory Services",
      digitia_label: "Digital Business Solutions",
    },
    divisions: {
      europath: {
        name: "Europath Consultancy",
        tag: "Your Path to Europe.",
        overline: "Advisory Services",
        intro:
          "Our flagship advisory division. Whether you are moving to Spain, studying in Europe, launching a business, or seeking a job — we handle the complexity so you can focus on the goal.",
        items: [
          "Tourist, Student & Business Visa Assistance",
          "Student Enrolment & Admission Guidance",
          "Company & Business Setup in Spain",
          "Business Relocation Services",
          "Office, Shop & Commercial Property Search",
          "Supplier & Vendor Sourcing",
          "Employment & Job-Search Assistance",
          "CV Preparation & Career Guidance",
          "Administrative Paperwork & Documentation",
        ],
        business_overline: "Business Setup & Relocation",
        business_intro:
          "End-to-end support for entrepreneurs relocating or launching a venture in Spain — company formation, banking, property, licences and ongoing paperwork.",
        business_items: [
          "Company Formation & Registration",
          "Business & Investor Visa Filing",
          "Bank Account Opening (Corporate)",
          "Accounting, Tax & Payroll Services",
          "Restaurant, Café & Bar Setup",
          "Retail Shop Setup & Licensing",
          "Hotel & Hospitality Business Setup",
          "Commercial Property Search",
          "Supplier & Vendor Sourcing",
          "Import & Export Documentation",
          "Legal & Regulatory Compliance",
          "Ongoing Advisory & Representation",
        ],
      },
      digitia: {
        name: "Digitia",
        tag: "Digital Business Solutions.",
        overline: "Design · Automation · Systems",
        intro:
          "Our digital division builds the tools, brand and systems modern businesses need to run — from a beautiful logo to a fully automated ordering and delivery platform, and even the interior of your restaurant or shop.",
        pillars: [
          { t: "Design & Branding", d: "Websites, logos, printed & digital menus and marketing materials that make your business look world-class." },
          { t: "Interior & Space Design", d: "Office and restaurant interior concepts that turn empty spaces into destinations customers love." },
          { t: "Automation & Systems", d: "Ordering, delivery, POS, AI assistants and CRM — the invisible engine that runs your business 24/7." },
        ],
        items: [
          "Website Design & Development",
          "Logo Design & Brand Identity",
          "Menus, Business Cards & Print",
          "Office & Restaurant Interior Design",
          "Signage & Environmental Branding",
          "Business Automation",
          "Online Ordering Systems",
          "Delivery Platform Integrations",
          "POS & Inventory Systems",
          "AI Assistants & Chatbots",
          "WhatsApp Business Automation",
          "Reservation & Booking Systems",
          "SEO & Google Business Profile",
          "Social Media Management",
          "Analytics & Sales Dashboards",
          "Ongoing Digital Support",
        ],
        industries: [
          { k: "Restaurants & Cafés", v: "Design · Ordering · Menus" },
          { k: "Bars & Nightlife", v: "Interior · Reservations" },
          { k: "Retail & Shops", v: "Branding · E-commerce" },
          { k: "Hotels & Rentals", v: "Bookings · Automation" },
          { k: "Salons & Studios", v: "Design · CRM" },
          { k: "Startups & SMEs", v: "Brand · Web · AI" },
        ],
        cta_primary: "Design & Automate",
        cta_secondary: "See What We Build",
      },
    },
    why: {
      title: "Why Choose Us",
      sub: "A trusted European advisory built on transparency, professionalism and measurable client outcomes.",
      items: [
        { t: "European Advisory Expertise", d: "Decades of combined experience in Spanish and European bureaucracy, education and business." },
        { t: "Personalised Guidance", d: "Every case is reviewed individually — no templates, no shortcuts." },
        { t: "Transparent Process", d: "Honest assessments, clear timelines and visibility on every step." },
        { t: "Fast Response Time", d: "We reply in hours — across WhatsApp, email and phone." },
        { t: "One Team, All Services", d: "Advisory + digital under one roof — no juggling multiple providers." },
        { t: "Reliable & Compliant", d: "Documented, audit-ready processes for individuals and businesses." },
        { t: "Long-Term Partnership", d: "We stay with our clients long after the paperwork is done." },
      ],
    },
    process: {
      title: "Our Process",
      sub: "Five carefully designed steps that take you from first enquiry to successful outcome.",
      steps: [
        { t: "Free Consultation", d: "Schedule a no-cost call to discuss your goals, budget and timeline." },
        { t: "Case Assessment", d: "We evaluate your situation, documents and eligibility for the right European pathway or business route." },
        { t: "Planning & Strategy", d: "A tailored roadmap with institutions, authorities, suppliers, timelines and required documents." },
        { t: "Documentation & Execution", d: "End-to-end assistance with applications, translations, submissions and vendor coordination." },
        { t: "Successful Outcome", d: "Confirmed visa, admission, business launch or placement — with continuous post-arrival support." },
      ],
    },
    about: {
      overline: "About Us",
      title: "An advisory built to open doors",
      lead:
        "Mercurio Advisors Group is a Valencia-based consultancy connecting individuals, families and businesses with the right opportunities across Spain and Europe — advising beyond borders, beyond paperwork and beyond expectations.",
      mission_t: "Our Mission",
      mission_d:
        "To make Spain and Europe accessible to ambitious individuals and businesses through honest, professional and personalised advisory — supported by modern digital tools.",
      vision_t: "Our Vision",
      vision_d:
        "To be the most trusted advisory group between international clients, European institutions and the businesses that call Spain home.",
      values_t: "Core Values",
      values: ["Integrity", "Professionalism", "Transparency", "Reliability", "Client Success"],
      approach_t: "Our Approach",
      approach_d:
        "Professional, client-focused, transparent. We work as long-term partners — not transactional agents — guiding you with measurable milestones and clear communication at every stage.",
    },
    services: {
      overline: "What We Do",
      title: "Two divisions. One promise of excellence.",
      sub:
        "Advisory that opens doors across Europe — and digital that keeps your business running once you step through them.",
      primary: "Advisory Division",
      secondary: "Digital Division",
    },
    contact: {
      overline: "Get in Touch",
      title: "Speak with an advisor today",
      sub:
        "Tell us about your goal — visa, admission, company setup, job search, website or automation — and we'll respond within one business day.",
      labels: {
        name: "Full Name",
        phone: "Phone Number",
        email: "Email Address",
        country: "Country",
        service: "Service Required",
        message: "Message",
      },
      placeholders: {
        name: "e.g. Maria López",
        phone: "+34 742 020 511",
        email: "you@example.com",
        country: "Select your country",
        service: "Select a service",
        message: "Briefly describe what you need help with…",
      },
      services_options: [
        "Tourist / Student / Business Visa Assistance",
        "Student Enrolment & Admission",
        "Company & Business Setup",
        "Business Relocation",
        "Commercial Property Search",
        "Supplier & Vendor Sourcing",
        "Employment & Job-Search Assistance",
        "CV Preparation & Career Guidance",
        "Administrative Paperwork",
        "Digitia — Website & Logo Design",
        "Digitia — Menus & Brand Materials",
        "Digitia — Office / Restaurant Design",
        "Digitia — Business Automation",
        "Digitia — Ordering & Delivery Systems",
        "Other",
      ],
      submit: "Request Free Consultation",
      success_t: "Request received",
      success_d: "Thank you — an advisor will contact you shortly.",
      error_t: "Submission failed",
      error_d: "Please check your details and try again.",
      info_t: "Contact information",
      hours_t: "Office Hours",
      hours_d: "Monday – Friday · 09:00 – 18:00 CET",
      address_t: "Office",
      address_d: "Carlos Cervera 14, L'Eixample, 46006 Valencia, Spain",
    },
    footer: {
      tagline: "Advising Beyond Borders — visas, business, careers and digital across Spain and Europe.",
      explore: "Explore",
      divisions_h: "Divisions",
      contact_h: "Contact",
      legal: "All Rights Reserved.",
      built: "European Advisory Group",
    },
  },
  es: {
    nav: {
      home: "Inicio",
      about: "Nosotros",
      services: "Servicios",
      digital: "Digitia",
      contact: "Contacto",
      cta: "Consulta Gratuita",
    },
    common: {
      free_consultation: "Consulta Gratuita",
      whatsapp_now: "WhatsApp Ahora",
      contact_us: "Contáctanos",
      learn_more: "Saber Más",
      our_divisions: "Nuestras Divisiones",
      primary_division: "División de Asesoría",
      secondary_division: "División Digital",
      brand: "Mercurio Advisors Group",
      brand_short: "Mercurio",
      brand_sub: "Advisors Group",
      slogan: "Asesorando Más Allá de las Fronteras",
    },
    hero: {
      overline: "Valencia · España · Europa",
      title_a: "Asesorando",
      title_b: "Más Allá de las",
      title_c: "Fronteras",
      sub:
        "Mercurio Advisors Group ayuda a personas, familias, emprendedores y empresas a establecerse y prosperar en España y Europa — desde visados y admisiones hasta constitución de empresas, transformación digital y todo lo que hay en medio.",
      europath_label: "Servicios de Asesoría",
      digitia_label: "Soluciones Digitales para Negocios",
    },
    divisions: {
      europath: {
        name: "Europath Consultancy",
        tag: "Tu Camino a Europa.",
        overline: "Servicios de Asesoría",
        intro:
          "Nuestra división principal de asesoría. Tanto si te mudas a España, estudias en Europa, lanzas un negocio o buscas empleo — gestionamos la complejidad para que tú te centres en el objetivo.",
        items: [
          "Asistencia con Visados de Turista, Estudiante y Negocios",
          "Matrícula y Orientación de Admisión Estudiantil",
          "Constitución y Registro de Empresas en España",
          "Servicios de Relocalización Empresarial",
          "Búsqueda de Oficinas, Locales y Propiedades Comerciales",
          "Búsqueda de Proveedores y Distribuidores",
          "Asistencia en Búsqueda de Empleo",
          "Preparación de CV y Orientación Profesional",
          "Trámites y Documentación Administrativa",
        ],
        business_overline: "Constitución y Relocalización de Empresas",
        business_intro:
          "Apoyo integral para emprendedores que se relocalizan o lanzan un negocio en España — constitución de empresa, banca, propiedad, licencias y trámites continuos.",
        business_items: [
          "Constitución y Registro de Empresas",
          "Tramitación de Visado de Negocios e Inversor",
          "Apertura de Cuenta Bancaria (Corporativa)",
          "Contabilidad, Impuestos y Nóminas",
          "Montaje de Restaurantes, Cafeterías y Bares",
          "Apertura y Licencias de Tiendas",
          "Montaje de Hoteles y Negocios de Hostelería",
          "Búsqueda de Locales Comerciales",
          "Búsqueda de Proveedores y Distribuidores",
          "Documentación de Importación y Exportación",
          "Cumplimiento Legal y Regulatorio",
          "Asesoría y Representación Continua",
        ],
      },
      digitia: {
        name: "Digitia",
        tag: "Soluciones Digitales para Negocios.",
        overline: "Diseño · Automatización · Sistemas",
        intro:
          "Nuestra división digital crea las herramientas, marca y sistemas que un negocio moderno necesita — desde un logotipo elegante hasta una plataforma de pedidos y delivery totalmente automatizada, e incluso el interior de tu restaurante o tienda.",
        pillars: [
          { t: "Diseño y Marca", d: "Webs, logos, cartas impresas y digitales y materiales de marketing que hacen que tu negocio luzca de nivel mundial." },
          { t: "Diseño de Interiores", d: "Conceptos de interior para oficinas y restaurantes que convierten espacios vacíos en destinos memorables." },
          { t: "Automatización y Sistemas", d: "Pedidos, delivery, TPV, asistentes de IA y CRM — el motor invisible que hace funcionar tu negocio 24/7." },
        ],
        items: [
          "Diseño y Desarrollo Web",
          "Logotipo e Identidad de Marca",
          "Cartas, Tarjetas y Materiales Impresos",
          "Diseño de Interiores (Oficina/Restaurante)",
          "Señalización y Branding Ambiental",
          "Automatización de Negocio",
          "Sistemas de Pedidos Online",
          "Integración con Plataformas de Delivery",
          "TPV y Sistemas de Inventario",
          "Asistentes de IA y Chatbots",
          "Automatización de WhatsApp Business",
          "Sistemas de Reservas y Citas",
          "SEO y Perfil de Google Business",
          "Gestión de Redes Sociales",
          "Analítica y Paneles de Ventas",
          "Soporte Digital Continuo",
        ],
        industries: [
          { k: "Restaurantes y Cafés", v: "Diseño · Pedidos · Cartas" },
          { k: "Bares y Ocio Nocturno", v: "Interior · Reservas" },
          { k: "Retail y Tiendas", v: "Marca · E-commerce" },
          { k: "Hoteles y Alojamientos", v: "Reservas · Automatización" },
          { k: "Salones y Estudios", v: "Diseño · CRM" },
          { k: "Startups y PYMEs", v: "Marca · Web · IA" },
        ],
        cta_primary: "Diseñar y Automatizar",
        cta_secondary: "Ver Lo Que Creamos",
      },
    },
    why: {
      title: "Por Qué Elegirnos",
      sub: "Una asesoría europea de confianza basada en transparencia, profesionalismo y resultados medibles.",
      items: [
        { t: "Experiencia Asesora Europea", d: "Décadas de experiencia combinada en burocracia, educación y negocios en España y Europa." },
        { t: "Atención Personalizada", d: "Revisamos cada caso de forma individual — sin plantillas, sin atajos." },
        { t: "Proceso Transparente", d: "Evaluaciones honestas, plazos claros y visibilidad en cada paso." },
        { t: "Respuesta Rápida", d: "Respondemos en horas — por WhatsApp, email o teléfono." },
        { t: "Un Solo Equipo, Todos los Servicios", d: "Asesoría + digital bajo un mismo techo — sin necesidad de coordinar varios proveedores." },
        { t: "Fiable y Conforme", d: "Procesos documentados y listos para auditoría, para particulares y empresas." },
        { t: "Colaboración a Largo Plazo", d: "Acompañamos al cliente mucho después de completar los trámites." },
      ],
    },
    process: {
      title: "Nuestro Proceso",
      sub: "Cinco pasos cuidadosamente diseñados que te llevan desde la primera consulta hasta el éxito.",
      steps: [
        { t: "Consulta Gratuita", d: "Agenda una llamada sin coste para hablar de objetivos, presupuesto y plazos." },
        { t: "Evaluación del Caso", d: "Analizamos tu situación, documentos y elegibilidad para la ruta europea o el modelo de negocio adecuado." },
        { t: "Planificación y Estrategia", d: "Una hoja de ruta a medida con instituciones, autoridades, proveedores, plazos y documentos." },
        { t: "Documentación y Ejecución", d: "Asistencia integral con solicitudes, traducciones, envíos y coordinación de proveedores." },
        { t: "Resultado Exitoso", d: "Visado, admisión, lanzamiento de negocio o colocación confirmados — con soporte continuo tras la llegada." },
      ],
    },
    about: {
      overline: "Nosotros",
      title: "Una asesoría creada para abrir puertas",
      lead:
        "Mercurio Advisors Group es una consultora en Valencia que conecta a personas, familias y empresas con las oportunidades adecuadas en España y Europa — asesorando más allá de las fronteras, más allá del papeleo y más allá de las expectativas.",
      mission_t: "Nuestra Misión",
      mission_d:
        "Hacer accesibles España y Europa a personas y empresas ambiciosas mediante asesoría honesta, profesional y personalizada — apoyada por herramientas digitales modernas.",
      vision_t: "Nuestra Visión",
      vision_d:
        "Ser el grupo asesor más confiable entre clientes internacionales, instituciones europeas y los negocios que llaman hogar a España.",
      values_t: "Valores Fundamentales",
      values: ["Integridad", "Profesionalismo", "Transparencia", "Fiabilidad", "Éxito del Cliente"],
      approach_t: "Nuestro Enfoque",
      approach_d:
        "Profesional, centrado en el cliente y transparente. Trabajamos como socios a largo plazo — no como agentes transaccionales — guiándote con hitos medibles y comunicación clara en cada etapa.",
    },
    services: {
      overline: "Qué Hacemos",
      title: "Dos divisiones. Una sola promesa de excelencia.",
      sub:
        "Asesoría que abre puertas en toda Europa — y digital que mantiene tu negocio funcionando una vez las cruzas.",
      primary: "División de Asesoría",
      secondary: "División Digital",
    },
    contact: {
      overline: "Contacto",
      title: "Habla con un asesor hoy mismo",
      sub:
        "Cuéntanos tu objetivo — visado, admisión, constitución de empresa, búsqueda de empleo, web o automatización — y te respondemos en un día hábil.",
      labels: {
        name: "Nombre Completo",
        phone: "Teléfono",
        email: "Correo Electrónico",
        country: "País",
        service: "Servicio Requerido",
        message: "Mensaje",
      },
      placeholders: {
        name: "ej. Maria López",
        phone: "+34 742 020 511",
        email: "tu@ejemplo.com",
        country: "Selecciona tu país",
        service: "Selecciona un servicio",
        message: "Cuéntanos brevemente en qué podemos ayudarte…",
      },
      services_options: [
        "Asistencia con Visados (Turista/Estudiante/Negocios)",
        "Matrícula y Admisión Estudiantil",
        "Constitución de Empresa",
        "Relocalización Empresarial",
        "Búsqueda de Locales Comerciales",
        "Búsqueda de Proveedores",
        "Asistencia en Búsqueda de Empleo",
        "Preparación de CV y Orientación",
        "Trámites Administrativos",
        "Digitia — Diseño Web y Logotipo",
        "Digitia — Cartas y Materiales de Marca",
        "Digitia — Diseño de Oficina / Restaurante",
        "Digitia — Automatización de Negocio",
        "Digitia — Sistemas de Pedidos y Delivery",
        "Otro",
      ],
      submit: "Solicitar Consulta Gratuita",
      success_t: "Solicitud recibida",
      success_d: "Gracias — un asesor te contactará en breve.",
      error_t: "Error al enviar",
      error_d: "Por favor revisa los datos e inténtalo de nuevo.",
      info_t: "Información de contacto",
      hours_t: "Horario de Oficina",
      hours_d: "Lunes – Viernes · 09:00 – 18:00 CET",
      address_t: "Oficina",
      address_d: "Carlos Cervera 14, L'Eixample, 46006 Valencia, España",
    },
    footer: {
      tagline: "Asesorando más allá de las fronteras — visados, negocios, carreras y digital en España y Europa.",
      explore: "Explorar",
      divisions_h: "Divisiones",
      contact_h: "Contacto",
      legal: "Todos los Derechos Reservados.",
      built: "Grupo Asesor Europeo",
    },
  },
};

export const COUNTRIES = [
  "Spain","Portugal","France","Italy","Germany","United Kingdom","Netherlands","Belgium","Ireland","Poland",
  "India","Pakistan","Bangladesh","Sri Lanka","Nepal",
  "United States","Canada","Mexico","Brazil","Argentina","Colombia",
  "Morocco","Algeria","Tunisia","Egypt","Nigeria","Kenya","South Africa",
  "United Arab Emirates","Saudi Arabia","Qatar","Turkey",
  "China","Japan","South Korea","Philippines","Indonesia","Vietnam","Thailand",
  "Australia","New Zealand","Other",
];

export const CONTACT = {
  phone: "+34 742 020 511",
  phone_link: "tel:+34742020511",
  whatsapp: "+34 742 020 511",
  whatsapp_link: "https://wa.me/34742020511",
  email: "info@mercurioadvisorsgroup.eu",
  emails_extra: [
    "admissions@mercurioadvisorsgroup.eu",
    "digital@mercurioadvisorsgroup.eu",
  ],
  address: "Carlos Cervera 14, L'Eixample, 46006 Valencia, Spain",
  city: "Valencia, Spain",
  maps_embed:
    "https://www.google.com/maps?q=Carlos+Cervera+14,+46006+Valencia,+Spain&output=embed",
  social: {
    linkedin: "#",
    facebook: "#",
    instagram: "#",
    whatsapp: "https://wa.me/34742020511",
  },
};
